import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ArchitectureRel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M37.568 8.641c4.42.1 6.529 3.516 6.429 6.73-.1 3.114-2.31 6.127-6.429 6.227h-1.607c-2.913-.1-4.42-2.21-4.42-4.419 0-2.21 1.507-4.319 4.42-4.42h1.005c1.406.101 2.21 1.005 2.41 2.11.302 1.406-.502 3.013-2.41 3.013-1.206 0-1.206-1.808 0-1.808a.792.792 0 0 0 .803-.803c0-1.005-1.506-1.005-2.109-.904-2.812.703-3.114 5.223.402 5.323h1.607c2.611 0 4.72-1.808 4.72-4.42 0-2.61-2.109-4.921-4.72-4.921H6.432c-2.612 0-4.721 2.31-4.721 4.922 0 2.611 2.11 4.419 4.72 4.419H8.04c3.415-.1 3.214-4.62.401-5.323-.703-.201-2.109-.1-2.109.904 0 .401.302.803.804.803 1.205 0 1.205 1.808 0 1.808-1.909 0-2.712-1.607-2.41-3.013.2-1.105 1.004-2.009 2.41-2.11h1.004c2.913.101 4.42 2.21 4.42 4.42s-1.507 4.319-4.42 4.42H6.432C2.213 21.497.104 18.383.003 15.37c-.1-3.214 2.01-6.63 6.429-6.73h31.136Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M36.765 39.276a.9.9 0 0 1-.904.904H8.24c-1.206 0-1.206-1.808 0-1.808h6.629V13.965a.9.9 0 0 1 .904-.904.9.9 0 0 1 .904.904v24.307h4.52V13.965a.9.9 0 0 1 .903-.904.9.9 0 0 1 .904.904v24.307h4.52V13.965a.9.9 0 0 1 .904-.904.9.9 0 0 1 .904.904v24.307h6.63c.3.1.803.502.803 1.004ZM7.336 4.724a.9.9 0 0 1 .904-.904h27.62a.9.9 0 0 1 .905.904.9.9 0 0 1-.904.904H8.24a.9.9 0 0 1-.904-.904Z"
  })));
});
ArchitectureRel.displayName = 'ArchitectureRel';
ArchitectureRel.defaultProps = {
  'aria-label': 'ArchitectureRel'
};
export default ArchitectureRel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/ArchitectureRel.js
// module id = 3604
// module chunks = 11